import { HiOutlineSearch, HiX } from 'react-icons/hi';
import { TextInput } from '@mantine/core';

type props = {
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
  placeholder?: string;
  width?: string | number;
};

const TextSearchBox = ({ searchQuery, setSearchQuery, placeholder, width = '230px' }: props) => {
  return (
    <TextInput
      leftSection={<HiOutlineSearch color="#757575" size={15} />}
      rightSection={!!searchQuery && <HiX color="#757575" onClick={() => setSearchQuery('')} />}
      placeholder={placeholder}
      radius="5px"
      size="30px"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      styles={{
        input: {
          // background: '#F7F7F8',
          // border: 'none',
          fontSize: '13px',
        },
      }}
      w={width}
    />
  );
};

export default TextSearchBox;
